import type { GetInteractionAggregatesReqGroupBy } from '@/api/generated/model';

export type SegmentKind = 'team' | 'market' | 'tenure';

export function segmentKindLabel(kind: SegmentKind, plural = false): string {
  const labels: Record<SegmentKind, { singular: string; plural: string }> = {
    team: { singular: 'team', plural: 'teams' },
    market: { singular: 'market', plural: 'markets' },
    tenure: { singular: 'tenure', plural: 'tenure segments' },
  };
  return plural ? labels[kind].plural : labels[kind].singular;
}

export function buildSegmentGroupBy(kind: SegmentKind): GetInteractionAggregatesReqGroupBy {
  return { kind } as GetInteractionAggregatesReqGroupBy;
}
